<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="学生姓名:">
              <el-input v-model.trim="where.studentName" maxlength="11" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="getStudentData(where.studentName)" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button @click="(where = {}) && getStudentData()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table
        class="table"
        ref="table"
        :config="studentTable"
        :data="studentData"
        :choose.sync="chooseStudent"
        highlight-current-row
        height="calc(100vh - 330px)"
      >
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="studentName" label="姓名" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="branchName" label="部系" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="gradeName" label="年级" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="className" label="班级" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="210px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link slot="reference" icon="el-icon-view" type="primary" :underline="false" @click="viewPersonal(row)">个人违纪详情</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!--个人违纪详情弹窗-->
    <el-dialog
      title="个人违纪详情"
      :visible.sync="showPerson"
      width="70%"
      @closed="(personalWhere = {}), (studentId = null)"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="personalWhere" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期选择:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
            /></el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="getPersonData" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div style="font-size: 20px;text-align: center;margin: 10px auto;font-weight: bolder;">分值：{{ score }}分</div>
      <ele-data-table
        ref="coreTable"
        :config="personalTable"
        :data="personalData"
        :row-key="getRowKey"
        height="calc(90vh - 261px)"
        highlight-current-row
        v-loading="loadingTable"
        element-loading-text="获取详情中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="padding-bottom: 20px;"
      >
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="studentName" label="姓名" sortable="custom" align="center" show-overflow-tooltip min-width="110" />
          <el-table-column prop="branchName" label="部系" sortable="custom" align="center" show-overflow-tooltip min-width="110" />
          <el-table-column prop="gradeName" label="年级" sortable="custom" align="center" show-overflow-tooltip min-width="110" />
          <el-table-column prop="className" label="班级" sortable="custom" align="center" show-overflow-tooltip min-width="110" />
          <el-table-column prop="behaviorName" label="行为" sortable="custom" align="center" show-overflow-tooltip min-width="110" />
          <el-table-column prop="score" label="分数" sortable="custom" align="center" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="时间" sortable="custom" align="center" show-overflow-tooltip min-width="140" />
          <el-table-column label="操作" width="210px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link slot="reference" icon="el-icon-edit" type="primary" @click="openEditBehavior(row)" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此数据吗？" @onConfirm="removeData(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-dialog>
    <!--修改弹窗-->
    <el-dialog
      title="修改违纪详情"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-form-item label="行为:" prop="behaviorId">
          <el-select v-model="editForm.behaviorId" placeholder="请选择行为" class="ele-block" clearable @change="handleBehavior" style="width: 100%">
            <el-option v-for="item in behaviorList" :key="item.id" :label="item.behaviorName" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    delBehaviorEvaluationItem,
    getStudent,
    getStudentBehaviorList,
    studentBehaviorExport,
    studentBehaviorList,
    updateBehaviorEvaluationItem,
  } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        where: {},
        studentTable: {
          page: false,
        },
        studentData: [],
        chooseStudent: [],
        showStudent: false,
        personalData: [],
        personalTable: {
          page: false,
        },
        showPerson: false,
        getRowKey(row) {
          return row.id;
        },
        loadingTable: false,
        personalWhere: {},
        studentId: null,
        date: null,
        aa: null,
        score: null,
        behaviorList: [],
        studentBeId: null,
        showEdit: false,
        editForm: {},
        editRules: {
          behaviorId: [{ required: true, message: '请选择行为', trigger: 'change' }],
        },
      };
    },
    created() {
      this.getStudentData(this.where.studentName);
    },
    methods: {
      // 查询学生列表
      getStudentData(studentName) {
        getStudent({ studentName: studentName }).then((res) => {
          if (res.data.resCode == 200) {
            this.studentData = res.data.data;
          }
        });
        if (studentName != undefined) {
        } else {
          this.studentData = [];
        }
      },
      // 查看个人违纪情况
      viewPersonal(row) {
        this.setSelectTime();
        this.personalWhere.studentId = row.id;
        this.studentId = row.id;
        getStudentBehaviorList(this.personalWhere).then((res) => {
          if (res.data.resCode == 200) {
            this.personalData = res.data.data.list;
            this.score = res.data.data.score;
            this.showPerson = true;
          }
        });
      },
      // 默认本月日期
      setSelectTime() {
        var _this = this;
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        var start_month = y + '-' + '01'; //开始月份：本年第一月份
        var end_month = `${y}-${m}`; //结束月份： 本年当前月份

        var start_day = y + '-' + m + '-' + '01'; //开始日期： 本月第一天
        var end_day = `${y}-${m}-${d}`; //结束日期： 本月今天

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.personalWhere.startTime = start_day; // 传入后台的 开始时间
        this.personalWhere.endTime = end_day; // 传入后台的 结束时间
      },
      // 查询个人违纪详情
      getPersonData() {
        this.personalWhere.startTime = this.date[0];
        this.personalWhere.endTime = this.date[1];
        if (this.personalWhere != {}) {
          getStudentBehaviorList(this.personalWhere).then((res) => {
            if (res.data.resCode == 200) {
              this.personalData = res.data.data.list;
              this.score = res.data.data.score;
            }
          });
        }
      },
      // 修改
      openEditBehavior(row) {
        // this.studentBeId = row.id;
        this.editForm.id = row.id;
        studentBehaviorList().then((res) => {
          if (res.data.resCode == 200) {
            this.behaviorList = res.data.data;
            this.showEdit = true;
          }
        });
      },
      handleBehavior(item) {
        const id = item;
        let data = this.behaviorList.find((beItem) => beItem.id == id);
        this.editForm.behaviorName = data.behaviorName;
        if (data.scoreStatus == 1) {
          this.editForm.score = data.score;
        } else if (data.scoreStatus == 2) {
          this.editForm.score = '-' + data.score;
        }
      },
      submitEdit() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            updateBehaviorEvaluationItem(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.getPersonData();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除
      removeData(row) {
        delBehaviorEvaluationItem({ id: row.id }).then((res) => {
          if (res.data.resCode == 200) {
            this.getPersonData();
            this.$message({ type: 'success', message: '已删除' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      exportData() {
        let data = {
          startTime: this.personalWhere.startTime,
          endTime: this.personalWhere.endTime,
          studentId: this.studentId,
        };
        studentBehaviorExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
